import { Component, Input, ContentChild } from '@angular/core';
import { ListProps, listContentStyles } from '@kite_aerolab/shared/components';
import { ListDescriptionDirective } from './list-description.directive';

@Component({
  selector: 'kite-list-content',
  template: `
  <div [ngClass]="listContentStyles" ref="listContent">
    <ng-container *ngIf="!description">
      <ng-content select="[listSubtitle]"></ng-content>
    </ng-container>
    <ng-content select="[listTitle]"></ng-content>
    <ng-content select="[listDescription]"></ng-content>
  </div>
  `,
})
export class ListContentComponent {
  @ContentChild(ListDescriptionDirective, { static: false }) description: ListDescriptionDirective;
  /**
   * Tamaño del list: sm o extra small
   */
  @Input() size: ListProps['size'];

  public get listContentStyles(): string[] {
    return [listContentStyles().className];
  }
}
